import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ExtjsService } from "@core/services/extjs/extjs.service";

@Component({
  selector: "app-core-page-extjs-wildcard",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ""
})
export class ExtjsWildcardRouteComponent implements OnInit, OnDestroy {
  private readonly _service: ExtjsService = inject(ExtjsService);

  ngOnInit (): void {
    this._service.isWildCardRouted.set(true);
    this._service.wasWildCardRouted.set(true);
  }

  ngOnDestroy (): void {
    this._service.isWildCardRouted.set(false);
  }
}
